export default "__VITE_ASSET__7359f9a8__"